import { Product } from '../types';

// ============================================
// JOINTER HOLDERS & RELAY WITH BASE
// ============================================

// JOINTER HOLDERS
export const jointerHolderSpecialProducts: Product[] = [
  {
    id: "jointer-holder-al-special",
    name: "Ashok Leyland Joint Holder - Special Wire",
    slug: "jointer-holder-al-special-wire",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "Ashok Leyland joint holder with special wire. 9 inch long.",
    partNumber: "SH2200201",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200201.jpg",
    featured: true,
    specifications: {
      "Type": "Joint Holder",
      "Compatible": "Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "ashok-leyland", "special-wire"],
    applications: ["Ashok Leyland", "Wire Jointing"],
  },
  {
    id: "jointer-holder-universal-special",
    name: "Universal Joint Holder - Special Wire",
    slug: "jointer-holder-universal-special-wire",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "Universal joint holder with special wire.",
    partNumber: "SH2200211",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200211.jpg",
    featured: true,
    specifications: {
      "Type": "Joint Holder",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "universal", "special-wire"],
    applications: ["Universal Applications", "Wire Jointing"],
  },
  {
    id: "jointer-holder-universal-4mm",
    name: "Universal Joint Holder - Special & 4mm Deluxe Wire",
    slug: "jointer-holder-universal-4mm-wire",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "Universal joint holder with special & 4mm deluxe wire.",
    partNumber: "SH2200221",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200221.jpg",
    specifications: {
      "Type": "Joint Holder",
      "Wire Type": "Special & 4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "universal", "4mm"],
    applications: ["Universal Applications", "Wire Jointing"],
  },
  {
    id: "jointer-holder-4mm-1",
    name: "Joint Holder - 4mm Deluxe Wire",
    slug: "jointer-holder-4mm-wire-1",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "Joint holder with 4mm deluxe wire.",
    partNumber: "SH2200231",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200231.jpg",
    specifications: {
      "Type": "Joint Holder",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "4mm"],
    applications: ["Universal Applications", "Wire Jointing"],
  },
  {
    id: "jointer-holder-4mm-2",
    name: "Joint Holder - 4mm Deluxe Wire (Type 2)",
    slug: "jointer-holder-4mm-wire-2",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "Joint holder with 4mm deluxe wire.",
    partNumber: "SH2200241",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200241.jpg",
    specifications: {
      "Type": "Joint Holder",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "4mm"],
    applications: ["Universal Applications", "Wire Jointing"],
  },
  {
    id: "jointer-holder-4mm-3",
    name: "Joint Holder - 4mm Deluxe Wire (Type 3)",
    slug: "jointer-holder-4mm-wire-3",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "Joint holder with 4mm deluxe wire.",
    partNumber: "SH2200551",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200551.jpg",
    specifications: {
      "Type": "Joint Holder",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "4mm"],
    applications: ["Universal Applications", "Wire Jointing"],
  },
  {
    id: "jointer-holder-5mm",
    name: "Joint Holder - 5mm Deluxe Wire",
    slug: "jointer-holder-5mm-wire",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "Joint holder with 5mm deluxe wire.",
    partNumber: "SH2200552",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200552.jpg",
    specifications: {
      "Type": "Joint Holder",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "5mm"],
    applications: ["Universal Applications", "Wire Jointing"],
  },
  {
    id: "jointer-holder-ecm",
    name: "Joint Holder - ECM Wire",
    slug: "jointer-holder-ecm-wire",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "Joint holder with ECM wire.",
    partNumber: "SH2200601",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200601.jpg",
    specifications: {
      "Type": "Joint Holder",
      "Wire Type": "ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "ecm"],
    applications: ["ECM Applications", "Wire Jointing"],
  },
  {
    id: "jointer-holder-h8-h11-5mm",
    name: "H8 & H11 Joint Holder - 5mm Deluxe Wire",
    slug: "jointer-holder-h8-h11-5mm-wire",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "H8 & H11 joint holder with 5mm deluxe wire.",
    partNumber: "SH2200651",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200651.jpg",
    featured: true,
    specifications: {
      "Type": "Joint Holder",
      "Compatible": "H8 & H11 Bulbs",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "h8", "h11", "5mm"],
    applications: ["H8 Bulb", "H11 Bulb", "Headlight Jointing"],
  },
  {
    id: "jointer-holder-4mm-4",
    name: "Joint Holder - 4mm Deluxe Wire (Type 4)",
    slug: "jointer-holder-4mm-wire-4",
    category: "Jointer Holders",
    subcategory: "Joint Holders",
    description: "Joint holder with 4mm deluxe wire.",
    partNumber: "SH2200653",
    image: "/products/jointer-holders-relay/jointer-holders/SH2200653.jpg",
    specifications: {
      "Type": "Joint Holder",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jointer", "holder", "4mm"],
    applications: ["Universal Applications", "Wire Jointing"],
  },
];

// RELAY WITH BASE - 4 PIN RELAYS
export const relay4PinProducts: Product[] = [
  {
    id: "relay-4pin-denso-mini-12v",
    name: "12V 4 Pin Denso Mini Relay With Base - 4mm & 5mm Wire",
    slug: "relay-4pin-denso-mini-12v-4-5mm",
    category: "Relay With Base",
    subcategory: "4 Pin Relay",
    description: "12V 4 pin Denso mini relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB041201",
    image: "/products/jointer-holders-relay/relay-with-base/SRB041201.jpg",
    featured: true,
    specifications: {
      "Voltage": "12V",
      "Pins": "4 Pin",
      "Type": "Denso Mini Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "4-pin", "denso", "mini", "12v", "base"],
    applications: ["Universal Vehicles", "Relay Switching"],
  },
  {
    id: "relay-4pin-mini-12v",
    name: "12V 4 Pin Mini Relay With Base - 4mm & 5mm Wire",
    slug: "relay-4pin-mini-12v-4-5mm",
    category: "Relay With Base",
    subcategory: "4 Pin Relay",
    description: "12V 4 pin mini relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB041202",
    image: "/products/jointer-holders-relay/relay-with-base/SRB041202.jpg",
    featured: true,
    specifications: {
      "Voltage": "12V",
      "Pins": "4 Pin",
      "Type": "Mini Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "4-pin", "mini", "12v", "base"],
    applications: ["Universal Vehicles", "Relay Switching"],
  },
  {
    id: "relay-4pin-transparent-12v",
    name: "12V 4 Pin Transparent Relay With Base - 5mm & 6mm Wire",
    slug: "relay-4pin-transparent-12v-5-6mm",
    category: "Relay With Base",
    subcategory: "4 Pin Relay",
    description: "12V 4 pin transparent relay with relay base. 5mm & 6mm deluxe wire.",
    partNumber: "SRB041204",
    image: "/products/jointer-holders-relay/relay-with-base/SRB041204.jpg",
    featured: true,
    specifications: {
      "Voltage": "12V",
      "Pins": "4 Pin",
      "Type": "Transparent Relay",
      "Features": "With Relay Base",
      "Wire Type": "5mm & 6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "4-pin", "transparent", "12v", "base"],
    applications: ["Universal Vehicles", "Relay Switching"],
  },
  {
    id: "relay-4pin-starting-12v-5-7mm",
    name: "12V 4 Pin Starting Relay With Base - 5mm & 7mm Wire",
    slug: "relay-4pin-starting-12v-5-7mm",
    category: "Relay With Base",
    subcategory: "4 Pin Relay",
    description: "12V 4 pin starting relay with relay base. 5mm & 7mm deluxe wire.",
    partNumber: "SRB041207",
    image: "/products/jointer-holders-relay/relay-with-base/SRB041207.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "4 Pin",
      "Type": "Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "5mm & 7mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "4-pin", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
  {
    id: "relay-4pin-denso-mini-12v-4-5mm-2",
    name: "12V 4 Pin Denso Mini Relay With Base - 4mm & 5mm Wire (Type 2)",
    slug: "relay-4pin-denso-mini-12v-4-5mm-2",
    category: "Relay With Base",
    subcategory: "4 Pin Relay",
    description: "12V 4 pin Denso mini relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB041208",
    image: "/products/jointer-holders-relay/relay-with-base/SRB041208.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "4 Pin",
      "Type": "Denso Mini Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "4-pin", "denso", "mini", "12v", "base"],
    applications: ["Universal Vehicles", "Relay Switching"],
  },
  {
    id: "relay-4pin-starting-12v-4-5mm",
    name: "12V 4 Pin Starting Relay With Base - 4mm & 5mm Wire",
    slug: "relay-4pin-starting-12v-4-5mm",
    category: "Relay With Base",
    subcategory: "4 Pin Relay",
    description: "12V 4 pin starting relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB041211",
    image: "/products/jointer-holders-relay/relay-with-base/SRB041211.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "4 Pin",
      "Type": "Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "4-pin", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
  {
    id: "relay-4pin-starting-12v-6-8mm",
    name: "12V 4 Pin Starting Relay With Base - 6mm & 8mm Wire",
    slug: "relay-4pin-starting-12v-6-8mm",
    category: "Relay With Base",
    subcategory: "4 Pin Relay",
    description: "12V 4 pin starting relay with relay base. 6mm & 8mm deluxe wire.",
    partNumber: "SRB041214",
    image: "/products/jointer-holders-relay/relay-with-base/SRB041214.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "4 Pin",
      "Type": "Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "6mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "4-pin", "starting", "12v", "base", "heavy-duty"],
    applications: ["Commercial Vehicles", "Heavy Duty Starting"],
  },
  {
    id: "relay-4pin-starting-12v-4mm",
    name: "12V 4 Pin Starting Relay With Base - 4mm Wire",
    slug: "relay-4pin-starting-12v-4mm",
    category: "Relay With Base",
    subcategory: "4 Pin Relay",
    description: "12V 4 pin starting relay with relay base. 4mm deluxe wire.",
    partNumber: "SRB041216",
    image: "/products/jointer-holders-relay/relay-with-base/SRB041216.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "4 Pin",
      "Type": "Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "4-pin", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
];

// RELAY WITH BASE - 5 PIN RELAYS
export const relay5PinProducts: Product[] = [
  {
    id: "relay-5pin-mini-12v",
    name: "12V 5 Pin Mini Relay With Base - 4mm & 5mm Wire",
    slug: "relay-5pin-mini-12v-4-5mm",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin mini relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB051201",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051201.jpg",
    featured: true,
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Mini Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "mini", "12v", "base"],
    applications: ["Universal Vehicles", "5-Pin Relay Switching"],
  },
  {
    id: "relay-5pin-starting-12v-4-5mm-1",
    name: "12V 5 Pin Starting Relay With Base - 4mm & 5mm Wire",
    slug: "relay-5pin-starting-12v-4-5mm-1",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin starting relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB051204",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051204.jpg",
    featured: true,
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
  {
    id: "relay-5pin-starting-12v-5-6mm",
    name: "12V 5 Pin Starting Relay With Base - 5mm & 6mm Wire",
    slug: "relay-5pin-starting-12v-5-6mm",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin starting relay with relay base. 5mm & 6mm deluxe wire.",
    partNumber: "SRB051207",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051207.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "5mm & 6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
  {
    id: "relay-5pin-mini-12v-4-5mm-2",
    name: "12V 5 Pin Mini Relay With Base - 4mm & 5mm Wire (Type 2)",
    slug: "relay-5pin-mini-12v-4-5mm-2",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin mini relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB051209",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051209.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Mini Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "mini", "12v", "base"],
    applications: ["Universal Vehicles", "5-Pin Relay Switching"],
  },
  {
    id: "relay-5pin-starting-12v-4-5mm-2",
    name: "12V 5 Pin Starting Relay With Base - 4mm & 5mm Wire (Type 2)",
    slug: "relay-5pin-starting-12v-4-5mm-2",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin starting relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB051211",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051211.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
  {
    id: "relay-5pin-small-starting-12v",
    name: "12V 5 Pin Small Starting Relay With Base - 4mm & 5mm Wire",
    slug: "relay-5pin-small-starting-12v-4-5mm",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin small starting relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB051213",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051213.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Small Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "small", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
  {
    id: "relay-5pin-starting-12v-5-6mm-2",
    name: "12V 5 Pin Starting Relay With Base - 5mm & 6mm Wire (Type 2)",
    slug: "relay-5pin-starting-12v-5-6mm-2",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin starting relay with relay base. 5mm & 6mm deluxe wire.",
    partNumber: "SRB051216",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051216.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "5mm & 6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
  {
    id: "relay-5pin-starting-12v-4-5mm-3",
    name: "12V 5 Pin Starting Relay With Base - 4mm & 5mm Wire (Type 3)",
    slug: "relay-5pin-starting-12v-4-5mm-3",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin starting relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB051217",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051217.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
  {
    id: "relay-5pin-small-starting-12v-4-5mm-2",
    name: "12V 5 Pin Small Starting Relay With Base - 4mm & 5mm Wire (Type 2)",
    slug: "relay-5pin-small-starting-12v-4-5mm-2",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin small starting relay with relay base. 4mm & 5mm deluxe wire.",
    partNumber: "SRB051219",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051219.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Small Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "small", "starting", "12v", "base"],
    applications: ["Universal Vehicles", "Starting System"],
  },
  {
    id: "relay-5pin-big-starting-12v",
    name: "12V 5 Pin Big Starting Relay With Base - 5mm & 6mm Wire",
    slug: "relay-5pin-big-starting-12v-5-6mm",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "12V 5 pin big starting relay with relay base. 5mm & 6mm deluxe wire.",
    partNumber: "SRB051223",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051223.jpg",
    specifications: {
      "Voltage": "12V",
      "Pins": "5 Pin",
      "Type": "Big Starting Relay",
      "Features": "With Relay Base",
      "Wire Type": "5mm & 6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "big", "starting", "12v", "base"],
    applications: ["Commercial Vehicles", "Heavy Duty Starting"],
  },
];

// 24V RELAY
export const relay24VProducts: Product[] = [
  {
    id: "relay-5pin-mini-24v",
    name: "24V 5 Pin Mini Relay With Base - 4mm & 5mm Wire",
    slug: "relay-5pin-mini-24v-4-5mm",
    category: "Relay With Base",
    subcategory: "5 Pin Relay",
    description: "24V 5 pin mini relay with relay base. 4mm & 5mm deluxe wire. For heavy commercial vehicles.",
    partNumber: "SRB051213",
    image: "/products/jointer-holders-relay/relay-with-base/SRB051213.jpg",
    featured: true,
    specifications: {
      "Voltage": "24V",
      "Pins": "5 Pin",
      "Type": "Mini Relay",
      "Features": "With Relay Base",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay", "5-pin", "mini", "24v", "base", "commercial"],
    applications: ["Heavy Commercial Vehicles", "24V Systems"],
  },
];
